
import React, { useRef, useEffect, useState } from 'react';

interface ScannerViewProps {
  onScan: (code: string) => void;
  onClose: () => void;
}

const ScannerView: React.FC<ScannerViewProps> = ({ onScan, onClose }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let stream: MediaStream | null = null;
    const startCamera = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' }
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        setError("无法访问摄像头");
      }
    };
    startCamera();
    return () => stream?.getTracks().forEach(track => track.stop());
  }, []);

  return (
    <div className="absolute inset-0 z-[500] bg-black flex flex-col animate-in fade-in duration-300">
      <div className="flex justify-between items-center p-4 text-white z-10">
        <button onClick={onClose} className="p-2 active:scale-90 transition-transform">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
        <span className="font-bold text-[15px]">扫描核销</span>
        <div className="w-8"></div>
      </div>

      <div className="flex-1 relative flex flex-col items-center justify-center overflow-hidden">
        {error ? (
          <div className="text-white p-8 text-center bg-gray-900 absolute inset-0 flex flex-col items-center justify-center">
            <p className="mb-6 font-bold text-sm opacity-60">未获得相机权限</p>
            <button onClick={onClose} className="px-8 py-2 bg-white/10 border border-white/20 rounded-full text-xs font-bold">返回</button>
          </div>
        ) : (
          <>
            <video ref={videoRef} autoPlay playsInline className="absolute inset-0 w-full h-full object-cover opacity-60" />
            <div className="relative w-52 h-52 border-2 border-green-400 rounded-3xl scan-animation">
              <div className="absolute -top-1 -left-1 w-6 h-6 border-t-4 border-l-4 border-green-500 rounded-tl-xl"></div>
              <div className="absolute -top-1 -right-1 w-6 h-6 border-t-4 border-r-4 border-green-500 rounded-tr-xl"></div>
              <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-4 border-l-4 border-green-500 rounded-bl-xl"></div>
              <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-4 border-r-4 border-green-500 rounded-br-xl"></div>
            </div>
            <p className="absolute bottom-24 text-white text-[11px] font-bold bg-black/40 px-4 py-1.5 rounded-full backdrop-blur-md">请将核销码放入框内</p>
            <button onClick={() => onScan("11")} className="absolute bottom-8 px-8 py-2.5 bg-white/10 text-white rounded-full border border-white/20 backdrop-blur-md active:bg-white/20 transition-all text-xs font-bold">手动模拟扫码</button>
          </>
        )}
      </div>
    </div>
  );
};

export default ScannerView;
